module.exports = __webpack_public_path__ + "img/emoji.89613760.png";